export class HeartbeatManager {
  private _intervalId: any = null;
  private _isRunning = false;

  constructor(
    private readonly _heartbeatFn: () => Promise<void>,
    private readonly _intervalMs: number = 30000, // Default to 30 seconds
  ) {}

  public start(): void {
    if (this._isRunning) return;

    this._intervalId = setInterval(() => {
      this._heartbeatFn().catch(() => {});
    }, this._intervalMs);

    this._isRunning = true;
  }

  public stop(): void {
    if (this._intervalId) {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }
    this._isRunning = false;
  }

  public isRunning(): boolean {
    return this._isRunning;
  }
}
